<template>
  <svg
    role="img"
    :aria-label="title"
    class="o-icon o-spotify-icon"
    viewBox="2 2 19 19"
    width="40"
    height="40"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 3C7.02952 3 3 7.02941 3 11.9998C3 16.9705 7.02952 20.9996 11.9999 20.9996C16.9709 20.9996 21 16.9705 21 11.9998C21 7.02973 16.9709 3.00043 11.9998 3.00043L11.9999 3ZM16.1274 15.9804C15.9662 16.2448 15.6202 16.3286 15.3558 16.1663C13.2427 14.8756 10.5826 14.5833 7.44978 15.299C7.14789 15.3678 6.84697 15.1786 6.77819 14.8767C6.70909 14.5747 6.89748 14.2737 7.20012 14.205C10.6284 13.4214 13.5692 13.759 15.9415 15.2087C16.2059 15.371 16.2897 15.716 16.1274 15.9804ZM17.2288 13.5296C17.0257 13.86 16.5937 13.9643 16.2637 13.7612C13.8446 12.2739 10.1569 11.8432 7.29549 12.7118C6.92439 12.8239 6.53244 12.6148 6.41981 12.2443C6.30804 11.8732 6.51729 11.482 6.88774 11.3692C10.1563 10.3774 14.2196 10.8578 16.9978 12.565C17.3277 12.7681 17.4319 13.2002 17.2288 13.5297V13.5296ZM17.3235 10.9774C14.4228 9.25458 9.63714 9.09617 6.86772 9.9367C6.423 10.0716 5.95271 9.82052 5.81794 9.37581C5.68317 8.93088 5.93401 8.46091 6.37905 8.32571C9.55815 7.36062 14.843 7.54708 18.1826 9.5296C18.5835 9.767 18.7146 10.2836 18.4771 10.6831C18.2406 11.0831 17.7226 11.215 17.3239 10.9774H17.3235Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'SpotifyIcon',
  props: {
    title: {
      type: String,
      default: 'Spotify',
    },
  },
}
</script>
